import React, { FunctionComponent } from 'react';
import styles from './RecurringSeriesSteps.module.scss';

interface StepSectionProps {
    number?: number;
    title: string;
    children?: React.ReactNode;
}

export const StepSection: FunctionComponent<StepSectionProps> = props => (
    <section className={styles.step}>
        <h3 className={styles.heading}>
            {props.number !== undefined && <span className={styles.number}>{props.number}</span>}
            {props.title}
        </h3>
        {props.children}
    </section>
);

export default StepSection;
